export default "__VITE_ASSET__d6597bba__"